/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from 'react';
import { AutoComplete, Input, message } from 'antd';
import { DataService } from '../../../config/dataService/dataService';
// import './style.css'; // Include custom styles

const AutoCompleteInput = ({ apiEndpoint, onItemSelected, defaultValue = '', defaultSize = null, placeholder = 'Search...' }) => {
  const [options, setOptions] = useState([]); // Options for autocomplete
  const [loading, setLoading] = useState(false); // Loading state
  const [selectedLabel, setSelectedLabel] = useState(null); // Selected label to display
  const [searchValue, setSearchValue] = useState(''); // Current search value

  // Sync defaultValue to selectedLabel when the component mounts or when defaultValue changes
  useEffect(() => {
    if (!selectedLabel) setSelectedLabel(defaultValue);
  }, [defaultValue]);

  // Fetch suggestions from API
  const fetchSuggestions = async (query) => {
    try {
      setLoading(true);
      const response = await DataService.post(`/comps/query-selector`, { search: query });
      const { data = [] } = response.data || {};

      const formattedOptions = data.map((item) => ({
        value: item.id, // Assuming each item has an id and name
        label: item.title,
      }));

      setOptions(formattedOptions);
      setLoading(false);
    } catch (error) {
      message.error(`Error fetching suggestions: ${error.message}`);
      setLoading(false);
    }
  };

  // Handle search input change
  const handleSearch = (value) => {
    setSearchValue(value);
    if (onItemSelected) onItemSelected(null); // Trigger event
    if (selectedLabel && String(selectedLabel).length > 0) setSelectedLabel('')
    if (value) {
      fetchSuggestions(value);
    } else {
      setOptions([]);
      setSelectedLabel(''); // Clear the label when input is cleared
    }
  };

  // Handle item selection
  const handleSelect = (value, option) => {
    
    setSearchValue('');
    setSelectedLabel(option.label); // Display the selected label in the input field
    if (onItemSelected) onItemSelected(value || null); // Trigger event
  };

  return (
    <AutoComplete
      options={options}
      onSearch={handleSearch}
      onSelect={handleSelect}
      style={{ width: '100%' }}
      placeholder={placeholder}
      allowClear
      value={selectedLabel || searchValue} // Display the selected label or current search value
      notFoundContent={loading ? 'Loading...' : 'No Results Found'}
    >
      <Input className='h-9' size={defaultSize || 'middle'} />
    </AutoComplete>
  );
};

export default AutoCompleteInput;
